<!--
 * @Author: your name
 * @Date: 2021-06-22 13:58:39
 * @LastEditTime: 2021-06-23 10:37:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\components\EcIcon\src\index.vue
-->
<template>
  <div class="ec-icon">
    <el-radio-group v-model="iconComponent" size="mini" @change="handleChange">
      <el-radio :label="item" :key="index" v-for="(item, index) in icons"><ec-svg-icon :icon-class="item" /></el-radio>
    </el-radio-group>
  </div>      
</template>
<script >
import { icons } from '@/common/icon.js'
export default {
  name: "EcIcon",
  data () {
    return {
      icons: icons,
      iconComponent: ''
    }
  },
  model: {
    prop: 'icon',
    event: 'handleIcon'
  },
  props: {
    icon: {
      type: String,
      default: ''
    }
  },
  watch: {
    icon : {
      handler () {
        let icon = this.icon == 'icon-nav-9' ? 'icon-nav-9' : this.icon
        this.iconComponent  = icon || 'icon-nav-9'
      },
      immediate: true
    }
  },
  methods: {
    handleChange (val) {
     this.$emit('handleIcon', val)
    }
  },
  mounted() {
    if (!this.icon) {
      this.handleChange('icon-nav-9')
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EcIcon/src/index.vue